import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { IlPaginationV2 } from '../IlPaginationV2/index.js';

function IlDataTableV3Pagination(props) {
  return /*#__PURE__*/React__default.createElement(IlPaginationV2, _extends({
    page: props.page,
    pageSizes: props.pageSizes,
    pageSize: props.pageSize,
    totalItems: props.totalCount,
    onChange: function onChange(params) {
      props.onChange(params);
      if (params.pageSize !== props.pageSize) {
        props.onChangePageSize(params.pageSize);
      } else {
        props.onGoToPage(params.page - 1);
      }
    }
  }, props.standardPaginatorStrings));
}

export { IlDataTableV3Pagination as default };
